const STATUS_LABELS = {
  request: "대기",
  confirmed: "확정",
  visited: "완료",
  cancelled: "취소",
  noshow: "노쇼",
};
const STATUS_TYPES = {
  request: "warning",
  confirmed: "success",
  visited: "info",
  cancelled: "danger",
  noshow: "danger",
};

export default {
  statusLabel(status) {
    return STATUS_LABELS[status] || status;
  },
  statusType(status) {
    return STATUS_TYPES[status] || "";
  },
};
